<div class="home-area relative overflow-hidden">
  <div class="app-banner">
    <app-banner></app-banner>
  </div>
  <div class="app-plans-pricing my-5">
    <app-plans-pricing></app-plans-pricing>
  </div>
  <div class="app-services my-14">
    <app-services-section></app-services-section>
  </div>
  <div class="app-frequently">
    <app-frequently></app-frequently>
  </div>
  <div class="app-installation-questions">
    <app-installation-questions></app-installation-questions>
  </div>
  <div class="app-blog">
    <app-blog></app-blog>
  </div>
  <div class="app-about-us">
    <app-about-us></app-about-us>
  </div>
  <div class="app-subscribe">
    <app-subscribe></app-subscribe>
  </div>
  <div class="app-contact-info">
    <app-contact-info></app-contact-info>
  </div>
</div>
